import { memo } from "react";

function Count({ count, label }) {
    return (
        <div className="jlt-flex jlt-flex-col jlt-items-center jlt-justify-center">
            {/* A countdown digit is not a document heading. As <h2> these
                rendered four "00" headings ahead of every page's <h1>, so the
                first headings an extractor (or screen reader) met were "00". */}
            <div className="jlt-text-white jlt-text-2xl jlt-font-semibold">{count}</div>
            <p className="jlt-text-[#01ffdc] jlt-text-sm jlt-font-medium">{label}</p>
        </div>
    );
}

export default memo(Count);
